import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { Trader } from "../api/types";
import { useToast, errText, JsonArea, DirtyChip } from "../components/ui";

const TYPES = ["PAPER", "QMT", "MOOMOO", "CCXT"];

export default function Traders({ onChanged }: { onChanged: () => void }) {
  const notify = useToast();
  const [rows, setRows] = useState<Trader[]>([]);
  const [nn, setNn] = useState("");
  const [nt, setNt] = useState("PAPER");

  const load = () => api.listTraders().then(setRows).catch((e) => notify({ kind: "error", msg: errText(e) }));
  useEffect(() => { load(); }, []);

  const addNew = async () => {
    if (!nn.trim()) return;
    try { await api.upsertTrader(nn.trim(), { type: nt, params: {} }); setNn(""); load(); onChanged(); }
    catch (e) { notify({ kind: "error", msg: errText(e) }); }
  };

  return (
    <div>
      <div className="panel row">
        <div><label>新增执行器名称</label><input value={nn} onChange={(e) => setNn(e.target.value)} placeholder="如 paper" /></div>
        <div style={{ maxWidth: 160 }}><label>类型</label>
          <select value={nt} onChange={(e) => setNt(e.target.value)}>{TYPES.map((t) => <option key={t}>{t}</option>)}</select>
        </div>
        <div style={{ flex: "0 0 auto" }}><button className="primary" onClick={addNew}>新增</button></div>
      </div>
      {rows.map((t) => <TraderCard key={t.name} t={t} onSaved={() => { load(); onChanged(); }} />)}
      {rows.length === 0 && <div className="muted">暂无执行器</div>}
    </div>
  );
}

function TraderCard({ t, onSaved }: { t: Trader; onSaved: () => void }) {
  const notify = useToast();
  const [params, setParams] = useState<Record<string, unknown>>(t.params || {});
  const save = async () => {
    try { await api.upsertTrader(t.name, { type: t.type, params }); onSaved(); notify({ kind: "ok", msg: `已保存: ${t.name}` }); }
    catch (e) { notify({ kind: "error", msg: errText(e) }); }
  };
  const remove = async () => {
    if (!confirm(`删除执行器 ${t.name}?`)) return;
    try { await api.deleteTrader(t.name); onSaved(); } catch (e) { notify({ kind: "error", msg: errText(e) }); }
  };
  return (
    <div className="card">
      <div className="card-head">
        <span className="title mono">{t.name}</span>
        <span className="badge kind">{t.type}</span>
        <DirtyChip dirty={t.dirty} />
        <span className="spacer" />
        <button onClick={save}>保存草稿</button>
        <button className="danger" onClick={remove}>删除</button>
      </div>
      <div style={{ marginTop: 10 }}><label>参数 params（JSON）</label><JsonArea value={params} onChange={setParams} rows={4} /></div>
    </div>
  );
}
